import { Component } from '@angular/core';

@Component({
  selector: 'app-investment-reports',
  templateUrl: './investment-reports.component.html',
  styleUrl: './investment-reports.component.scss',
})
export class InvestmentReportsComponent {
  items = [
    {
      title: 'وصف ',
      content: `  ​صدرت أحكام القانون رقم 141 لسنة 2019 في 31 يوليو 2019 والذي أضاف إلى المادة (74) من قانون الاستثمار رقم 72 لسنة 2017 بند جديد برقم (14) يتيح للهيئة العامة للاستثمار والمناطق الحرة طلب البيانات والمعلومات اللازمة لحساب أصول الاستثمار الأجنبي المباشر وغير المباشر من الجهات العامة والخاصة للأغراض الإحصائية، دون الاخلال باعتبارات الأمن القومي أو الحق في الخصوصية وسرية المعلومات وبحماية حقوق الغير.

سوف يتم الاستعانة بالبيانات المستوفاة في النموذج الربع سنوي في الأغراض الإحصائية بهدف تدقيق بيانات تدفقات الاستثمارات الأجنبية الواردة إلى مصر، على أن يتم الإفصاح عن البيانات على المستوى الكلي فقط.

ويتطلب من كافة الشركات العاملة بجمهورية مصر العربية وتحتوي على مساهمات اجنبية بغض النظر عن جهة التأسيس استيفاء النموذج المشار إليه، ويستثنى منها فقط شركات البحث والتنقيب والتي تعمل وفقاً لاتفاقيات الإنتاج المشتركة مع الجهات الحكومية.  `,
      expanded: false,
    },
    {
      title: ' المتطلبات الأساسية ',
      content: `بيانات تعريفية عن الشركة

بيانات هيكل المساهمين ورأس مال الشركة

حقوق الملكية للشركة

المعاملات مع المساهمين الأجانب و/أو الأطراف ذو علاقة للمساهمين الأجانب `,
      expanded: false,
    },
    {
      title: ' المستندات المطلوبة ',
      content: ` 
بعد استيفاء النموذج الربع السنوي يتم تحميل كلا من:

سجل تجاري حديث

تفويض من الشركة لمقدم البيانات

اثبات شخصية المفوض

الميزانية حال توافرها `,
      expanded: false,
    },
    {
      title: '  الرسوم جنيه مصرى',
      content: ` لا توجد رسوم ولكن طبقاً للمادة رقم (91) من قانون الاستثمار رقم 72 لسنة 2017 يتم فرض غرامة قدرها "خمسون ألف جنيهاً مصرياً فقط لا غير" على الشركات التي تمتنع عن استيفاء النماذج

`,
      expanded: false,
    },
    {
      title: ' الإطار الزمني ',
      content: ` يتم استيفاء النموذج الربع سنوي 4 مرات سنوياً، في موعد اقصاه 45 يوم من تاريخ انتهاء كل الربع في 31 مارس – 30 يونيو – 30 سبتمبر – 31 ديسمبر

`,
      expanded: false,
    },
    {
      title: ' قنوات الخدمة ',
      content: ` البوابة الاكترونية
`,
      expanded: false,
    },
    {
      title: ' السياسات والإجراءات ',
      content: `يقوم ممثل عن الشركة بالتسجيل وإنشاء الحساب على البوابة الإلكترونية للهيئة (أو استخدام حساب مفعل مسبقاً).

ثم أختر "تقارير الاستثمار الأجنبي المباشر" من " الخدمات الإلكترونية" ثم انقر على "تقدم على الخدمة".

يتم استيفاء البيانات المطلوبة في نموذج احصاءات الاستثمارات الأجنبية الربع سنوي. 

دليل استرشادي لاستكمال النموذج الربع سنوي لإحصاءات الاستثمارات الأجنبية.pdf

يقوم ممثل الشركة بتحميل نسخة من تفويض الشركة موقعة ومختومة بالإضافة إلى نسخة من إثبات الشخصية.

يمكن حفظ النموذج واستكماله في وقت لاحق. كافة الطلبات المحفوظة متاحة علي مساحة العمل الخاصة بالشركة علي البوابة الالكترونية.

عندما تقوم الشركة باستيفاء النموذج للمرة الأولى، ستقوم باستيفاء البيانات عن الربع الحالي والربع السابق. عقب ذلك ستقوم الشركة بإدخال بيانات الربع الحالي فقط، وستظهر بيانات الربع السابق تلقائياً مع إمكانية تحديث البيانات في حالة وجود تحديث.

إذا كانت الشركة المصرية شركة قابضة، فإما أن تقوم الشركة باستيفاء النماذج وفقاً للبيانات المجمعة للشركات التابعة لها مع إدراج أسماء تلك الشركات، أو استيفاء نموذج لكل شركة على حدى وفقاً للبيانات المستقلة `,
      expanded: false,
    },
    {
      title: ' تحميل المستندات المساعدة ',
      content: ' ',
      expanded: false,
    },
  ];

  toggle(item: any) {
    item.expanded = !item.expanded;
  }
}
